import { useEffect } from "react";
import { useSelector } from "react-redux";
import { GeneralState } from "../Redux";
import { rtlTheme, ltrTheme } from "../Theme";

export const useTheme = () => {
  const isRtl = useSelector(GeneralState.Selectors.selectIsRtl);

  /* Change body direction based on theme direction */
  useEffect(() => {
    if (document) {
      document.body.dir = isRtl ? "rtl" : "ltr";
    }
  }, [isRtl]);

  const theme = isRtl ? rtlTheme : ltrTheme;

  return theme;
};
